import { CategoryConfig } from '../types';

export const categoryConfigs: CategoryConfig[] = [
  {
    id: '2f4a2eac-302c-49ea-a496-0b7a26b7e162',
    label: 'Indicações',
    icon: '📝',
    color: '#8B5CF6',
    description: ''
  },
  {
    id: "e02fa95e-c87c-44b9-a8cd-355cced0981b",
    label: 'Desabafo',
    icon: '🗨️',
    color: '#FF6B4A',
    description: ''
  },
  {
    id: "532c81a8-a88e-4da1-bc1f-acc189cb8839",
    label: 'Sonhos',
    icon: '✨',
    color: '#4f9ee3',
    description: ''
  },
  {
    id: "055fb0cd-db56-4a79-bbdf-4e8d0f736fe9",
    label: 'Assuntos Gerais',
    icon: '💡',
    color: '#F59E0B',
    description: ''
  },
  {
    id: "54f2877b-4aa3-438f-a772-11aa70b4216f",
    label: 'Trabalho',
    icon: '💼',
    color: '#14b8a6',
    description: ''
  },
  {
    id: "0a5313e1-6398-44d0-a63a-013423f73fc8",
    label: 'Relacionamento',
    icon: '💕',
    color: '#EC4899',
    description: ''
  },
  {
    id: "2abe1fe9-9e1d-4d2a-92f9-3548476aba54",
    label: 'Capítulos',
    icon: '📖',
    color: '#F93d3d',
    description: ''
  },
  {
    id: "e4008e19-b4ed-40ea-bb91-11e0395255ca",
    label: 'Apresentação',
    icon: '🎉',
    color: '#ce30c1',
    description: ''
  },
  {
    id: '2b4a2eac-302c-49ea-a496-0b7a26b7e144',
    label: 'Sala de espera',
    icon: '🛋️',
    color: '#280671',
    description: ''
  },
  {
    id: '7a3389e5-c6dd-456c-bbc9-e5be41591065',
    label: 'GirlsPlaining',
    icon: '👩‍💻',
    color: '#f311ab',
    description: ''
  },
];

export const getCategoryConfig = (category: string ): CategoryConfig | undefined => {
  return categoryConfigs.find(config => config.label === category);
};